/**
 * Created by fyzu on 16.08.16.
 */


var CommercialService = (function () {

    'use strict';

    //************ Variables ************//
    var form;
    var company;
    var name;
    var position;
    var phone;
    var email;
    var message;
    var captcha;

    //************ Functions ************//
    function clear() {
        company.val("");
        name.val("");
        position.val("");
        phone.val("");
        email.val("");
        message.val("");
        grecaptcha.reset(captcha);
    }

    function submit() {

        var isValidate = true;

        if (company.val() == '') {
            isValidate = false;
            company.addClass('has-error');
        }

        if (name.val() == '') {
            isValidate = false;
            name.addClass('has-error');
        }

        if (position.val() == '') {
            isValidate = false;
            position.addClass('has-error');
        }

        var strPhone = phone.val().split('+').join('').split(' ').join('').split('-').join('').split('_').join('');

        if (strPhone.length < 11) {
            isValidate = false;
            phone.addClass('has-error');
        }

        if (email.val() == '') {
            isValidate = false;
            email.addClass('has-error');
        }

        if (message.val() == '') {
            isValidate = false;
            message.addClass('has-error');
        }

        if (grecaptcha.getResponse(captcha) == '') {
            form.find('.g-recaptcha').addClass('has-error');
            isValidate = false;
        }

        if (!isValidate) {
            return false;
        }

        AppService.toggleLoader();
        $.ajax({
            url: $(this).prop('action'),
            type: $(this).prop('method'),
            data: $(this).serialize(),
            success: function (response) {
                if (response.code == '200') {
                    clear();
                    $('#modalCommercialOffer').modal('hide');
                    $('.js-modal-success-message').html(
                        'Ваша заявка принята.<br>' +
                        'Мы рассмотрим её<br>' +
                        'в ближайшее время.'
                    );
                    AppService.toggleLoader();
                    $('#modalSuccess').modal('show');
                }
            },
            error: AppService.toggleLoader
        });

        return false;
    }

    function init() {
        form = $('.js-commercial-offer-form');
        if (form.length > 0) {
            company = form.find('#company');
            name = form.find('#name');
            position = form.find('#position');
            phone = form.find('#phone');
            email = form.find('#email');
            message = form.find('#message');
            captcha = CaptchaService.render(form.find('.g-recaptcha').get(0));

            form.on('submit', submit);
        }
    }

    //************ Public ************//
    return {
        init: init
    };
})();